var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useIsAuthenticated } from 'root/src/client/v2/auth/hooks/useIsAuthenticated';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { FormProvider, useForm } from 'react-hook-form';
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
import { ModalTitle } from 'root/src/client/v2/common/components/modal/ModalTitle';
import { getDateWithTimezone } from 'root/src/shared/util/getDateWithTimezone';
import { StreamDateField } from 'root/src/client/web/modal/PointsApplicationModal';
import { ButtonNew } from 'root/src/client/v2/common/components/form/ButtonNew';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { trpc } from 'root/src/client/v2/trpc/trpc';
import toast from 'react-hot-toast';
import { memo } from 'react';
import LoadingCircles from 'root/src/client/v2/common/components/LoadingCircles';
export const UpdatePointsApplicationModal = memo((props) => {
    const isAuthenticated = useIsAuthenticated();
    const modal = useModal();
    const { form, onSubmit } = useUpdatePointsApplicationModal(props);
    if (!isAuthenticated) {
        modal.hide();
        return null;
    }
    return (<ModalLayout className="max-w-[540px]">
			<FormProvider {...form}>
				<form onSubmit={onSubmit} className="flex flex-col gap-6">
					<ModalTitle>Update Points Application</ModalTitle>
					<p className="text-sm text-center">
						{props.drop.campaignName} launch date has been updated to <br /> {getDateWithTimezone(props.drop.liveDate)}.
					</p>
					<p className="text-xs">
						Please update your stream date to match the new launch date.
					</p>
					<StreamDateField drop={props.drop}/>
					<ButtonNew className="flex justify-center items-center h-10 py-0 flex-initial" type="submit" disabled={form.formState.isSubmitting}>
						{form.formState.isSubmitting ? <LoadingCircles width={20} height={20}/> : <>Save</>}
					</ButtonNew>
				</form>
			</FormProvider>
		</ModalLayout>);
});
const UpdatePointsApplicationFormSchema = z.object({
    streamDate: z.string({
        required_error: 'Stream date is required',
    }).datetime(),
});
const useUpdatePointsApplicationModal = (props) => {
    const modal = useModal();
    const updatePointsApplicationMutation = trpc.pointsApplication.update.useMutation();
    const form = useForm({
        resolver: zodResolver(UpdatePointsApplicationFormSchema),
    });
    const onSubmit = form.handleSubmit((values) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield updatePointsApplicationMutation.mutateAsync({
                dropId: props.drop.id,
                streamDate: values.streamDate,
            });
            toast.success('Points application updated, you will be notified if your application is accepted.', {
                duration: 6000,
            });
            modal.hide();
        }
        catch (err) {
            const message = err instanceof Error ? err.message : 'An error occurred';
            toast.error(message);
        }
    }));
    return {
        form,
        onSubmit,
    };
};
